<template>
  <div class="alert-resume-box" @click="$emit('close')">
    <div class="alert-box" @click.stop>
      <i class="iconfont iconx" @click="$emit('close')"></i>
      <p class="title">选择规划简历</p>
      <div class="cvs-list-box">
        <div class="cv-item" v-for="(item, index) in cvs" :key="index + 'cv'" @click="nowIndex = index">
          <i class="iconfont " :class="nowIndex === index ? 'iconxuanzhong' : 'iconweixuanzhong'"></i>
          <span class="cv-name">{{item.cv_name}}</span>
          <div class="score-box lang" v-show="item.lang">
            {{item.lang === 'cn' ? '中文' : '英文'}}
          </div>
          <div class="score-box" v-show="item.score != null && item.score != undefined">
            {{item.score}}
          </div>
        </div>
      </div>
      <div class="submit-btn" @click="debounced">
        开始规划
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from "vuex"
  import api from "../../../api";
  export default {
    name: "planning-resume-select",
    computed:{
      ...mapState('cv', ['cvs'])
    },
    data(){
      return {
        nowIndex: -1,
        debounced: null
      }
    },
    created() {
      this.debounced = this._.debounce(this.submit, 300);
    },
    methods: {
      async submit(){
        if(this.nowIndex == -1){
          this.$message.error("请选择要规划的简历")
          return
        }
        let {token, lang} = this.cvs[this.nowIndex];
        if(lang != 'cn'){
          this.$message.error("请选择中文简历")
          return
        }
        api.planning.getExperience(token).then(res=>{
          if(res.code === 1000 && (res.data.edus.length > 0 || res.data.works.length > 0)){
            this.$emit('close')
            window.open(`/planning/${token}/index`, '_blank')
          }else {
            this.$message.error(res.code === 1000 ? "请补充教育经历和工作经历后再进入" : res.message)
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
.alert-resume-box{
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  .alert-box{
    width: 520px;
    height: 394px;
    background: #FFFFFF;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.13);
    border-radius: 12px;
    box-sizing: border-box;
    padding: 36px 32px;
    position: relative;
    .iconx{
      position: absolute;
      top: 16px;
      right: 16px;
      color: #606060;
      font-size: 20px;
      cursor: pointer;
    }
    .title{
      font-size: 16px;
      font-weight: 500;
      color: #404040;
      line-height: 14px;
      margin-bottom: 16px;
    }
    .subtitle{
      font-size: 14px;
      font-weight: 400;
      color: #909090;
      line-height: 14px;
      margin-bottom: 28px;
    }
    .cvs-list-box{
      width: 456px;
      height: 210px;
      background: #F9F9F9;
      border-radius: 4px;
      box-sizing: border-box;
      padding: 32px 24px;
      overflow: hidden;
      overflow-y: scroll;
      &::-webkit-scrollbar{
        display: none;
      }
    }
    .cv-item{
      margin-bottom: 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      color: #404040;
      .score-box{
        width: 55px;
        height: 24px;
        background: rgba(255, 102, 68, .1);
        border-radius: 2px;
        text-align: center;
        line-height: 24px;
        color: #FF4F4C;
        font-size: 12px;
        margin-left: 8px;
      }
      .lang{
        background-color: rgba(65, 131, 255, 0.08);
        color: #4183FF;
      }
      i{
        margin-right: 18px;
        font-size: 18px;

      }
      .iconxuanzhong{
        color: #FF6644;
      }
      .iconweixuanzhong{
        color:#CFCFCF
      }
      .cv-name{
        flex:1;
        overflow:hidden; //超出的文本隐藏
        text-overflow:ellipsis; //溢出用省略号显示
        white-space:nowrap; //溢出不换行（一行内容）
        font-size: 14px;
        font-weight: 400;
        color: #404040;
      }
    }
    .submit-btn{
      margin: 36px auto;
      width: 210px;
      height: 46px;
      background: linear-gradient(180deg, #FF9F79 0%, #FF6644 100%);
      border-radius: 25px;
      color: #fff;
      font-size: 16px;
      line-height: 46px;
      text-align: center;
      cursor: pointer;
    }
  }
}
</style>
